import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocsFolderBookmark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M72.151 61.099H10.565A1.567 1.567 0 0 1 9 59.534v-10.2a7.843 7.843 0 0 1 7.843-7.843H81.56a7.843 7.843 0 0 0-7.843 7.843v10.2c0 .867-.707 1.565-1.565 1.565Z"
        fill="#78B441"
      />
      <path
        d="M24.686 49.325a7.843 7.843 0 0 0-7.843-7.844C12.516 41.481 9 44.998 9 49.324v.49l15.686 4.507v-4.996Z"
        fill="#599F40"
      />
      <path
        d="M24.686 51.295h61.889v-1.961a7.843 7.843 0 0 0-7.844-7.843H16.843a7.843 7.843 0 0 1 7.843 7.843v1.96Z"
        fill="#78B441"
      />
      <path
        d="M46.265 51.295h40.319v-1.961a7.843 7.843 0 0 0-7.843-7.843H38.412l7.843 9.804h.01Z"
        fill="#599F40"
      />
      <path
        d="M96.973 51.295H24.686l-1.668 41.488c-.16 4.006 3.045 7.344 7.051 7.344h61.502c4.007 0 7.212-3.338 7.051-7.344l-1.668-41.488h.019Z"
        fill="#78B441"
      />
      <path
        d="M35.084 51.295H24.688l-1.678 41.677c-.16 3.902 2.97 7.155 6.872 7.155 3.903 0 7.023-3.253 6.872-7.155l-1.678-41.677h.01Z"
        fill="#599F40"
      />
      <path
        d="m36.753 92.972 63.774 3.62a7.06 7.06 0 0 1-6.119 3.525H29.89c3.903 0 7.023-3.252 6.872-7.155l-.009.01Z"
        fill="#599F40"
      />
      <path
        d="M35.052 50.495a.8.8 0 0 1 .831.768l1.68 41.675.005.407a7.675 7.675 0 0 1-7.678 7.582.8.8 0 0 1 0-1.6 6.075 6.075 0 0 0 6.074-6.322v-.001l-1.68-41.677a.8.8 0 0 1 .768-.832Zm-10.334 0a.8.8 0 0 1 .768.832l-.396 9.832a.8.8 0 0 1-1.6-.064l.397-9.832a.8.8 0 0 1 .831-.768Z"
        fill="#0F172A"
      />
      <path d="M29.787 51.295v45.494l-4.214-45.494h4.214Z" fill="#78B441" />
      <path d="M96.973 50.495a.8.8 0 1 1 0 1.6H24.686a.8.8 0 1 1 0-1.6h72.287Z" fill="#0F172A" />
      <path d="M28.987 96.79V51.295a.8.8 0 1 1 1.6 0V96.79a.8.8 0 0 1-1.6 0Z" fill="#0F172A" />
      <path
        d="M51.412 59.619a1.957 1.957 0 0 0-1.96-1.886H45.53a1.959 1.959 0 0 0-1.961 2.037l.179 4.534.056 1.358a1.957 1.957 0 0 0 1.961 1.885h3.922a1.959 1.959 0 0 0 1.96-2.036l-.047-1.198-.188-4.685v-.01Z"
        fill="#007A5F"
      />
      <path
        d="M49.46 56.934a2.762 2.762 0 0 1 2.736 2.376l.025.273v.004l.188 4.684v.011l.047 1.195a2.759 2.759 0 0 1-2.76 2.87h-3.921a2.757 2.757 0 0 1-2.761-2.657l-.056-1.353v-.001l-.18-4.532-.001-.147a2.76 2.76 0 0 1 2.762-2.723h3.921Zm-1.753 6.011a.673.673 0 0 0-.67.671v.688a.8.8 0 0 1-.8.8h-1.645l.022.524v.005a1.157 1.157 0 0 0 1.16 1.114h3.922a1.16 1.16 0 0 0 1.162-1.202v-.003l-.018-.438h-1.662a.8.8 0 0 1-.8-.8v-.688a.673.673 0 0 0-.67-.67Zm-2.168-4.412c-.662 0-1.19.55-1.162 1.202v.003l.15 3.766h.916a2.27 2.27 0 0 1 2.264-2.158 2.27 2.27 0 0 1 2.265 2.158h.806l-.156-3.85-.01-.117a1.162 1.162 0 0 0-1.152-1.004h-3.92Z"
        fill="#0F172A"
      />
      <path d="M45.812 77.888h10.86v4.11h-10.86v-4.11Z" fill="#fff" />
      <path d="M56.672 77.888h43.195v4.11H56.672v-4.11Z" fill="#CAE8DF" />
      <path d="M51.355 69.187h33.787v8.701H51.356v-8.7Z" fill="#fff" />
      <path d="M85.142 69.187h25.094v8.701H85.142v-8.7Z" fill="#A6DBCB" />
      <path d="M42.673 81.998h23.888v8.22H42.673v-8.22Z" fill="#fff" />
      <path d="M102.28 81.998H66.561v8.22h35.719v-8.22Z" fill="#CAE8DF" />
      <path d="M47.735 90.21h29.44v9.907h-29.44v-9.908Z" fill="#fff" />
      <path d="M77.185 90.21h29.441v9.907h-29.44v-9.908Z" fill="#A6DBCB" />
      <path
        d="M105.826 99.5v-8.48h-3.546a.8.8 0 0 1-.8-.802v-7.42h-1.613a.8.8 0 0 1-.8-.8v-4.11a.8.8 0 0 1 .8-.8h9.579v-7.101h-45.6a.8.8 0 1 1 0-1.6h46.4a.8.8 0 0 1 .799.8v8.701a.8.8 0 0 1-.799.8h-9.579v2.51h1.613a.8.8 0 0 1 .8.8v7.42h3.545a.8.8 0 0 1 .801.8V99.5a.801.801 0 0 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M96.51 92.558a.8.8 0 0 1 0 1.6H50.725a.8.8 0 0 1 0-1.6H96.51Zm7.457 0a.801.801 0 0 1 0 1.6h-2.413a.8.8 0 1 1 0-1.6h2.413Zm-55.26-7.25a.8.8 0 0 1 0 1.6h-2.414a.8.8 0 1 1 0-1.6h2.413Zm48.596-.046a.8.8 0 0 1 0 1.6H53.297a.8.8 0 0 1 0-1.6h44.006ZM101.111 20.13H62.922a4.904 4.904 0 0 0-4.901 4.901h38.188a4.904 4.904 0 0 1 4.902-4.902Z"
        fill="#80CCB5"
      />
      <path
        d="M59.284 63.22c-.358 1.612.028 3.356 1.197 4.534a4.887 4.887 0 0 0 3.47 1.433h38.188a4.904 4.904 0 0 1-4.902-4.902l8.541-38.189c.358-1.612-.029-3.356-1.198-4.534a4.885 4.885 0 0 0-3.469-1.433H62.923c1.357 0 2.583.547 3.469 1.433 1.169 1.169 1.565 2.913 1.197 4.534L59.284 63.22Z"
        fill="#fff"
      />
      <path
        d="M101.111 19.33c1.478 0 2.825.559 3.837 1.478l.198.188.002.002c1.389 1.4 1.818 3.436 1.41 5.272l-8.54 38.19a.8.8 0 0 1-1.562-.35l8.541-38.188c.308-1.387-.036-2.839-.983-3.795a4.086 4.086 0 0 0-2.903-1.198H62.922a.8.8 0 1 1 0-1.6h38.189Z"
        fill="#0F172A"
      />
      <path
        d="M63.95 69.187h38.189a4.905 4.905 0 0 0 4.902-4.902H68.852a4.904 4.904 0 0 1-4.902 4.902Z"
        fill="#CAE8DF"
      />
      <path
        d="M107.041 63.485a.8.8 0 0 1 .8.8 5.705 5.705 0 0 1-5.702 5.702H63.95a.8.8 0 0 1 0-1.6h38.189c1.99 0 3.65-1.42 4.023-3.302H89.328a.8.8 0 1 1 0-1.6h17.713Z"
        fill="#0F172A"
      />
      <path
        d="M96.134 30.915a.8.8 0 1 1 0 1.6H74.329a.8.8 0 1 1 0-1.6h21.805ZM95.06 35.723a.8.8 0 1 1 0 1.6H73.253a.8.8 0 1 1 0-1.6H95.06ZM93.975 40.54a.8.8 0 1 1 0 1.6H72.17a.8.8 0 1 1 0-1.6h21.805ZM92.9 45.357a.8.8 0 1 1 0 1.6H71.096a.8.8 0 1 1 0-1.6H92.9ZM91.826 50.165a.8.8 0 1 1 0 1.6H70.02a.8.8 0 1 1 0-1.6h21.805ZM90.742 54.982a.8.8 0 0 1 0 1.6H68.927a.8.8 0 1 1 0-1.6h21.815Z"
        fill="#B3C0D0"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocsFolderBookmark)
